/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import { defaultCreateAppData, ICreateAppData } from './IAppModels'

import { StepperComponent } from '../../../assets/ts/components'
import { isNotEmpty, KTIcon } from '../../../helpers'
// import {Step1} from './steps/Step1'
// import {Step2} from './steps/Step2'
// import {Step3} from './steps/Step3'
// import {Step4} from './steps/Step4'
// import {Step5} from './steps/Step5'
import { useFormik } from 'formik'
import { errorToast, successToast } from '../../../helpers/components/Toaster'
import {
  createUser,
  updateUser,
} from '../../../../app/modules/apps/data-administration/data-admininstration-list/core/_requests'
import { useListView } from '../../../../app/modules/apps/data-administration/data-admininstration-list/core/ListViewProvider'
import { useQueryResponse } from '../../../../app/modules/apps/data-administration/data-admininstration-list/core/QueryResponseProvider'
import * as Yup from 'yup'
import clsx from 'clsx'
import PasswordFormField from '../../../../app/modules/accounts/components/settings/cards/PasswordFiledForm'
import { UsersListLoading } from '../../../../app/modules/apps/data-administration/data-admininstration-list/components/loading/UsersListLoading'

type Props = {
  show: boolean
  handleClose: () => void
  user?: any
  isUserLoading?: boolean
}
const editUserSchema = (id) =>
  Yup.object().shape({
    name: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Name is required'),
    password: Yup.string().required('Password Required'),
    confirm_password: Yup.string()
      .label('confirm password')
      .required()
      .oneOf([Yup.ref('password'), 'Passwords must match'], 'Passwords must match'),
    mobileNumber: Yup.string()
      .matches(/^\d*$/, 'Only numbers are allowed')
      .trim('White space not allowed')
      .strict(true)
      .min(3, 'Minimum 3 symbols')
      .max(15, 'Maximum 50 symbols')
      .required('Mobile number is required'),
    email: Yup.string()
      .email('Invalid email address') // Custom error message
      .required('Email is required'),
  })

const modalsRoot = document.getElementById('root-modals') || document.body

const CreateAppModal = ({ show, handleClose, user = {}, isUserLoading }: Props) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [data, setData] = useState<ICreateAppData>(defaultCreateAppData)
  const [firstRun, setfirstRun] = useState(true)
  const [hasError, setHasError] = useState(false)
  const [userForEdit, setUserForEdit] = useState<any>({
    ...user,
    name: user?.personalDetails?.name || '',
    email: user?.personalDetails?.email || '',
    countryCode: user?.address?.country || '',
    mobileNumber: user?.personalDetails?.mobile || '',
  })

  useEffect(() => {
    if (Object.keys(user).length > 0 && firstRun) {
      setUserForEdit({
        id: user.id,
        name: user?.personalDetails?.name || '',
        email: user?.personalDetails?.email || '',
        countryCode: user?.address?.country || '',
        mobileNumber: user?.personalDetails?.mobile || '',
      })
      setfirstRun(false)
    }
  }, [firstRun, user])

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const { setItemIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const handleModalClose = () => {
    setfirstRun(true)
    handleClose()
  }

  const formik: any = useFormik({
    initialValues: userForEdit,
    enableReinitialize: true,
    validationSchema: editUserSchema(user.id),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const payload = {
          firstName: values.name,
          mobile: values.mobileNumber,
          userType: 'FRANCHISE_USER',
          email: values.email,
          status: 'ACTIVE',
          lastName: '',
          password: values?.password,
          address: {
            country: 'IN',
          },
        }
        console.log({ values })
        if (isNotEmpty(values.id)) {
          await updateUser(payload, `users/${user.id}/update`)
          successToast('Modified')
          // cancel(true)
          handleModalClose()
        } else {
          await createUser(payload, 'user/register')
          successToast('Added')
          // cancel(true)
          // handleClose()
          handleModalClose()
        }
      } catch (ex: any) {
        console.log({ ex: ex?.response?.data?.data })
        errorToast(ex?.response?.data?.data || 'Somethig Went Wrong')
        console.error(ex)
      } finally {
        setSubmitting(true)
      }
    },
  })

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={handleModalClose}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2>Add Manager</h2>
        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleModalClose}>
          <KTIcon className='fs-1' iconName='cross' />
        </div>
        {/* end::Close */}
      </div>

      <form
        id='kt_modal_add_user_form'
        className='form p-10'
        onSubmit={formik.handleSubmit}
        noValidate
      >
        <div className='fv-row mb-7'>
          <label className='required fw-bold fs-6 mb-2'>Name</label>
          <input
            placeholder='Enter name'
            {...formik.getFieldProps('name')}
            type='text'
            name='name'
            className={clsx(
              'form-control form-control-solid mb-3 mb-lg-0',
              { 'is-invalid': formik.touched.name && formik.errors.name },
              {
                'is-valid': formik.touched.name && !formik.errors.name,
              }
            )}
            autoComplete='off'
            disabled={formik.isSubmitting || isUserLoading}
          />
          {formik.touched.name && formik.errors.name && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.name}</span>
              </div>
            </div>
          )}
        </div>
        <div className='fv-row mb-7'>
          <label className='required fw-bold fs-6 mb-2'>Email</label>
          <input
            placeholder='Enter Email'
            {...formik.getFieldProps('email')}
            type='text'
            format='email'
            className={clsx(
              'form-control form-control-solid mb-3 mb-lg-0',
              { 'is-invalid': formik.touched.email && formik.errors.email },
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
            autoComplete='off'
            disabled={formik.isSubmitting || isUserLoading}
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.email}</span>
              </div>
            </div>
          )}
        </div>
        <div className='fv-row mb-7'>
          <label className='required fw-bold fs-6 mb-2'>Mobile number (To be used for login)</label>
          <input
            placeholder='91XXXXXXX'
            {...formik.getFieldProps('mobileNumber')}
            type='text'
            name='mobileNumber'
            className={clsx(
              'form-control form-control-solid mb-3 mb-lg-0',
              { 'is-invalid': formik.touched.mobileNumber && formik.errors.mobileNumber },
              {
                'is-valid': formik.touched.mobileNumber && !formik.errors.mobileNumber,
              }
            )}
            autoComplete='off'
            disabled={formik.isSubmitting || isUserLoading}
          />
          {formik.errors.mobileNumber && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.mobileNumber}</span>
              </div>
            </div>
          )}
        </div>
        <PasswordFormField ml={'60rem'} formik={formik} name={'password'} label={'Set password'} />
        <PasswordFormField
          ml={'60rem'}
          formik={formik}
          name={'confirm_password'}
          label={'Confirm Password'}
        />
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => handleModalClose()}
            className='btn btn-light me-3'
            data-kt-users-modal-action='cancel'
            disabled={formik.isSubmitting || isUserLoading}
          >
            Discard
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-users-modal-action='submit'
            style={{ backgroundColor: '#333333' }}
            disabled={isUserLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isUserLoading) && (
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>
      {(formik.isSubmitting || isUserLoading) && <UsersListLoading />}
    </Modal>,
    modalsRoot
  )
}

export { CreateAppModal }
